<template lang="html">
  <div class="inner double">
    <img v-for="img in images" :key="img.id" :src="img"/>
  </div>
</template>

<script>
export default {
  props: {
    images: Array
  },
  data() {
    return {
      x: null,
      y: null,
      open: false,
      readText: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.inner {
    width: 100%;
    height: 100%;
    position: relative;
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center center;
        opacity: 0;
        animation-name: fadein;
        animation-duration: 0.5s;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        animation-direction: normal;
        animation-timing-function: ease-out;
        @keyframes fadein {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
    }
    &.double {
        text-align: center;
        img {
            width: auto;
            max-width: 50%;
        }
    }
    p {
        width: 80%;
        position: absolute;
        top: 50%;
        left: 50%;
        text-align: left;
        transform: translate(-50%,-50%);
    }
}
</style>
